
export function SolutionsPreviewSection() {
  const solutions = [
    {
      title: "Upstream Exploration Solutions",
      subtitle: "Innovation Engine for Energy Discovery",
      description: "Leveraging AI and big data technology to provide comprehensive intelligent solutions from seismic interpretation to reservoir simulation, maximizing exploration success rates and asset value.",
      image: "https://public.readdy.ai/ai/img_res/c28da771ca760a889298bf1e2e6b3b6f.jpg",
      features: [
        "AI-powered seismic interpretation",
        "Intelligent reservoir modeling", 
        "Exploration data management",
        "Risk assessment optimization"
      ],
      link: "#upstream-solutions"
    },
    {
      title: "High-Tech Products & Solutions",
      subtitle: "Technology Bridge Across Industries",
      description: "Productizing core technologies refined from complex industrial scenarios, providing custom software development, advanced algorithms, and cross-industry technology solutions for high-tech enterprises.",
      image: "https://readdy.ai/api/search-image?query=Abstract%20technology%20interface%20with%20code%20visualization%2C%20advanced%20algorithm%20graphics%2C%20cross-industry%20technology%20concepts%2C%20sophisticated%20software%20development%20environment%2C%20deep%20blue%20gradient%20background%20with%20glowing%20elements&width=600&height=400&seq=solution2&orientation=landscape",
      features: [
        "Custom software development",
        "Advanced algorithm products",
        "Cross-industry solutions",
        "Technology consulting services"
      ],
      link: "#tech-solutions"
    }
  ];

  return (
    <section id="solutions" className="py-24 bg-gradient-to-b from-slate-800/50 to-slate-900/50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-6">
            Core <strong className="text-blue-400">Business Solutions</strong>
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Two comprehensive business segments delivering cutting-edge technology solutions globally
          </p>
        </div>

        <div className="space-y-16">
          {solutions.map((solution, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}
            >
              {/* Image */}
              <div className="lg:w-1/2">
                <div className="relative group">
                  <img 
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-80 object-cover rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-2xl"></div>
                </div>
              </div>

              {/* Content */}
              <div className="lg:w-1/2">
                <div className="max-w-xl">
                  <h3 className="text-3xl md:text-4xl font-light text-white mb-4">
                    {solution.title}
                  </h3>
                  <p className="text-xl text-blue-300 mb-6 font-light">
                    {solution.subtitle}
                  </p>
                  <p className="text-white/80 mb-8 leading-relaxed text-lg">
                    {solution.description}
                  </p>

                  {/* Features */}
                  <div className="grid grid-cols-2 gap-4 mb-8">
                    {solution.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-center gap-3">
                        <div className="w-2 h-2 bg-blue-400 rounded-full"></div>
                        <span className="text-white/70 text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>

                  <a 
                    href={solution.link}
                    className="inline-flex items-center gap-3 px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all duration-300 font-medium whitespace-nowrap cursor-pointer group"
                  >
                    Learn More
                    <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
